var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessPopupIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#44B269"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_315_6396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8153 12.0196C23.7311 12.2567 23.5571 12.4247 23.3852 12.5972C20.4941 15.4962 17.6041 18.3962 14.7158 21.2976C14.499 21.5153 14.2556 21.6465 13.9491 21.5461C13.8234 21.5048 13.6977 21.4254 13.6035 21.3313C12.3725 20.1043 11.1446 18.8738 9.92364 17.6367C9.81455 17.5274 9.7569 17.367 9.67578 17.2299C9.67578 17.1376 9.67578 17.0453 9.67578 16.953C9.76622 16.8183 9.83527 16.6607 9.95091 16.5541C10.186 16.3379 10.5495 16.3434 10.8036 16.5382C10.8619 16.5829 10.9151 16.6343 10.9672 16.6864C11.9828 17.7048 12.9984 18.7232 14.0129 19.7426C14.0519 19.7818 14.0837 19.8276 14.1482 19.9057C14.1979 19.8356 14.2266 19.7808 14.268 19.7388C17.0231 16.9724 19.7799 14.2074 22.5346 11.4403C22.7687 11.2053 23.0286 11.0911 23.3562 11.2091C23.6078 11.3001 23.7359 11.5007 23.8153 11.7423V12.0192V12.0196Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_315_6396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.1395,
    height: 10.4186,
    fill: "white",
    transform: "translate(9.67578 11.1626)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessPopupIcon);
export default __webpack_public_path__ + "static/media/success-popup-icon.6821a6f9a674a6c71a52cf8d3bae034b.svg";
export { ForwardRef as ReactComponent };